!function (r, e) {
  "object" == typeof exports && "undefined" != typeof module ? module.exports = e(require("react")) : "function" == typeof define && define.amd ? define(["react"], e) : (r = "undefined" != typeof globalThis ? globalThis : r || self).ReactDynamicImport = e(r.React);
}(this, function (r) {
  "use strict";

  function e(r) {
    return (e = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (r) {
      return typeof r;
    } : function (r) {
      return r && "function" == typeof Symbol && r.constructor === Symbol && r !== Symbol.prototype ? "symbol" : typeof r;
    })(r);
  }

  function t() {
    return (t = Object.assign || function (r) {
      for (var e = 1; e < arguments.length; e++) {
        var t = arguments[e];

        for (var n in t) {
          Object.prototype.hasOwnProperty.call(t, n) && (r[n] = t[n]);
        }
      }

      return r;
    }).apply(this, arguments);
  }

  function n(r, e) {
    if (null == r) return {};

    var t,
        n,
        o = function (r, e) {
      if (null == r) return {};
      var t,
          n,
          o = {},
          a = Object.keys(r);

      for (n = 0; n < a.length; n++) {
        t = a[n], e.indexOf(t) >= 0 || (o[t] = r[t]);
      }

      return o;
    }(r, e);

    if (Object.getOwnPropertySymbols) {
      var a = Object.getOwnPropertySymbols(r);

      for (n = 0; n < a.length; n++) {
        t = a[n], e.indexOf(t) >= 0 || Object.prototype.propertyIsEnumerable.call(r, t) && (o[t] = r[t]);
      }
    }

    return o;
  }

  function o(r, e) {
    return function (r) {
      if (Array.isArray(r)) return r;
    }(r) || function (r, e) {
      if ("undefined" == typeof Symbol || !(Symbol.iterator in Object(r))) return;
      var t = [],
          n = !0,
          o = !1,
          a = void 0;

      try {
        for (var i, u = r[Symbol.iterator](); !(n = (i = u.next()).done) && (t.push(i.value), !e || t.length !== e); n = !0) {
          ;
        }
      } catch (r) {
        o = !0, a = r;
      } finally {
        try {
          n || null == u.return || u.return();
        } finally {
          if (o) throw a;
        }
      }

      return t;
    }(r, e) || i(r, e) || function () {
      throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }();
  }

  function a(r) {
    return function (r) {
      if (Array.isArray(r)) return u(r);
    }(r) || function (r) {
      if ("undefined" != typeof Symbol && Symbol.iterator in Object(r)) return Array.from(r);
    }(r) || i(r) || function () {
      throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }();
  }

  function i(r, e) {
    if (r) {
      if ("string" == typeof r) return u(r, e);
      var t = Object.prototype.toString.call(r).slice(8, -1);
      return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? u(r, e) : void 0;
    }
  }

  function u(r, e) {
    (null == e || e > r.length) && (e = r.length);

    for (var t = 0, n = new Array(e); t < e; t++) {
      n[t] = r[t];
    }

    return n;
  }

  var c = function c(r) {
    var e = r.name,
        t = r.error.message;
    return "Unable to fetch module: ".concat(e, ".\nError: ").concat(t, ".");
  },
      f = function f() {
    return null;
  };

  return function (i) {
    var u = i.loader,
        l = i.isHOC,
        y = void 0 !== l && l,
        d = i.name,
        m = i.placeholder,
        s = void 0 === m ? f : m,
        p = i.errorHandler,
        b = void 0 === p ? c : p;
    if (!u || u && "function" != typeof u) throw new Error("'loader' is required and should be of type 'function'.");

    function h(i) {
      var c = r.useRef(!1),
          f = o(r.useState(null), 2),
          l = f[0],
          m = f[1],
          p = o(r.useState(null), 2),
          h = p[0],
          v = p[1],
          w = i.hocArgs,
          g = i.forwardedRef,
          O = n(i, ["hocArgs", "forwardedRef"]);
      return r.useEffect(function () {
        c.current = !0;
        var r = u(d);
        if (!r || r && !(r instanceof Promise)) throw new Error("Expected 'loader' to return a 'Promise', but, it returned '".concat(e(r), "' instead."));
        return r.then(function (r) {
          if (c.current) {
            var e = r.default || r;
            m({
              component: y ? e.apply(void 0, a(w)) : e
            });
          }
        }).catch(function (r) {
          c.current && v(r);
        }), function () {
          c.current = !1;
        };
      }, [w]), h ? r.createElement(b, {
        error: h,
        name: d
      }) : l ? r.createElement(l.component, t({}, O, {
        ref: g
      })) : r.createElement(s, {
        name: d
      });
    }

    function v(e, n) {
      return r.createElement(h, t({}, e, {
        forwardedRef: n
      }));
    }

    h.displayName = "DynamicImport".concat(y ? ":HOC" : "", "(").concat(d || "Unknown", ")"), v.displayName = "DynamicImportFetcher";
    return y ? function () {
      for (var e = arguments.length, n = new Array(e), o = 0; o < e; o++) {
        n[o] = arguments[o];
      }

      function a(e, o) {
        return r.createElement(h, t({}, e, {
          forwardedRef: o,
          hocArgs: n
        }));
      }

      return a.displayName = "DynamicImportHOCFetcher", r.forwardRef(a);
    } : r.forwardRef(v);
  };
});